export default __webpack_public_path__ + "static/media/hdpe-100.656598d0.jpg";